module.exports = __webpack_public_path__ + "static/media/Walking.904ec272.jpg";